import React from "react";
import { useState } from "react";
import Webcam from "react-webcam";
import WorkOrderDataService from "../services/WorkOrderDataService";const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const videoConstraints = {
  facingMode: FACING_MODE_USER,
  width: 800,
  height: 800
};

const WebcamCapture = (props) => {
  const [facingMode, setFacingMode] = React.useState(FACING_MODE_USER);
  const [imgSrc, setImgSrc] = useState(null); // initialize it
  const [hidden, setHidden] = useState("");

  const handleClick = React.useCallback(() => {
    setFacingMode(
      prevState =>
        prevState === FACING_MODE_USER
          ? FACING_MODE_ENVIRONMENT
          : FACING_MODE_USER
    );
  }, []);

  return (
    <>
      <button className={hidden} onClick={handleClick}>Switch camera</button>
      <br/><br/>
      <button className={hidden == "hidden"? "shown": "hidden"}
          onClick={() => {
            setHidden("");
          }}
        >
          Hiện thị Camera
      </button>
      <Webcam
        className={hidden !== "hidden"? "shown": "hidden"} 
        audio={false}
        screenshotFormat="image/jpeg"
        videoConstraints={{
          ...videoConstraints,
          facingMode
        }}
      >{({ getScreenshot }) => 
        (<>
          <br/><br/>
          <button className={hidden}
              onClick={() => {
                const imageSrc = getScreenshot();
                // console.log(imageSrc);
                setImgSrc(imageSrc);
                setHidden("hidden");
              }}
            >
              Chụp hình
          </button>
          <img src={imgSrc} alt="webcam" className={hidden == "hidden"? "shown": "hidden"} />
        </>)}
      </Webcam>
      <br/><br/>
      &nbsp;&nbsp;&nbsp;
      <button className={hidden == "hidden"? "shown": "hidden"}  
          onClick={() => {
            WorkOrderDataService.postShipInfo(props.workOrderId, {
                shippingImage: imgSrc,
                shippingCode: props.workOrderNo
              }).then(data => {
                props.newMessage(imgSrc);
              });
            }}
        >Lưu hình</button>
    </>
  );
};
export default WebcamCapture
